import { api_get } from "./utils"


const FakerAPI = {
	getName: _getName,
	getColor: _getColor,
}

async function _getName(gender: string) {
	const url = `/faker/name?gender=${gender}`;
	return api_get(url).then((res) => {
		return res.json();
	})
}
async function _getColor() {
	const url = '/faker/color';
	return api_get(url).then((res) => {
		return res.json();
	})
}

export default FakerAPI;
